<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'screen-groups-item',

    props: {
      group: {
        type: Object,
        required: true
      }
    },

    methods: {
      ...mapActions('app', [
        'showModal'
      ])
    }
  }
</script>

<template>
  <b-col md="3" sm="6" cols="12">
    <b-card class="mb-4" :class="{online: group.devices.length > 0}">
      <h5 class="count">{{ group.devices.length }}</h5>
      <font-awesome-icon :icon="['fal', 'desktop']" size="5x" class="icon"/>
      <h6>{{ group.name }}</h6>
      <p class="schedule">
        <font-awesome-icon :icon="['fal', 'clock']"/> {{ group.schedule.name || 'Unassigned' }}
      </p>
      <div slot="footer" class="actions">
        <b-button @click="showModal('ScreenGroupEditModal')">Edit</b-button>
        <b-button @click="showModal('ScreenGroupScheduleModal')">Schedule</b-button>
      </div>
    </b-card>
  </b-col>
</template>

<style src="./ScreenGroupsItem.scss" lang="scss" scoped></style>
